module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Medium.ac51547.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Medium.otf
// module id = lNhO
// module chunks = 6